export const DEFAULT_LOCALHOST = 'http://localhost:5000'
export const IC_HOST = 'https://icp0.io'

export const PLUG_DOCS_URL = 'https://docs.plugwallet.ooo/'
export const PLUG_SUPPORT_URL = 'https://support.plugwallet.ooo/'

// Hosts we own, and therefore the only places the content script is allowed to
// read campaign params from.
export const PLUG_FIRST_PARTY_HOSTS = ['plugwallet.ooo']

export const isFirstPartyHost = (hostname: string) =>
  PLUG_FIRST_PARTY_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`))
